// CLIENT SIDE
export const LOGIN = 'login';
export const CHANGE_PWD = '/change_pwd';
export const LANDING = '/';
export const HOME = '/home';
export const NEW_ORDER = '/home/new_order';
export const EDIT_ORDER = '/home/edit_order'
export const ORDERS_SUMMARY = '/home/get_orders';
export const HANDLE_USERS = '/home/handle_users';

const SERVERDIR = '/backend';
export const PATH = 'http://www.imperialordini.it'; 
export const LOGIN_PATH = PATH + SERVERDIR + '/login.php';
export const NEW_ORDER_PATH = PATH + SERVERDIR + '/new-order.php';
export const ORDERS_SUMMARY_PATH = PATH + SERVERDIR + '/orders-summary.php';




// WEBPACK FOOTER //
// ./src/routes/routes_production.js